module.exports = __webpack_public_path__ + "static/media/34_tn.275bd71d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/34_tn.jpg
// module id = 343
// module chunks = 0